var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"footer pa-0 ma-0 py-4 text-center d-block",attrs:{"absolute":""}},[_c('x-button',{staticClass:"button_type_ref",attrs:{"text":""},on:{"click":_vm.openAgreement}},[_vm._v(" Пользовательское соглашение ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }